import { 
  Directive, 
  Input, 
  inject, 
  HostListener, 
  ElementRef, 
  AfterViewInit 
} from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';

@Directive({
  selector: '[moneyFormat]',
  standalone: true,
  providers: [CurrencyPipe],
})
export class MoneyFormatDirective implements AfterViewInit {

  private el = inject(ElementRef);
  //private currencyPipe = inject(CurrencyPipe);

  constructor(private currencyPipe: CurrencyPipe) {}

  ngAfterViewInit() {
    const inputElement: HTMLInputElement = this.el.nativeElement;
    const value = inputElement.value.replace(/[^0-9]/g, '');
    const formattedValue = this.formatMoney(value);
    this.el.nativeElement.value = formattedValue;
  }

  /*
    @HostListener('input', ['$event'])
    onInput(event: any): void {
      const value = event.target.value.replace(/[^0-9]/g, '');
      console.log('const value: ' + value);
      const formattedValue = this.formatMoney(value);
      console.log('formattedValue: ' + value);
      this.el.nativeElement.value = formattedValue;
    }
  */

  private formatMoney(value: string): string {
    if (!value) return value;
    //const number = parseInt(value, 10);
    return this.currencyPipe.transform(value, 'USD', 'symbol', '1.0-0') || '';
  }
}
